export enum ModoSalvar {
    Post = 0,
    Put = 1
}
